/*
 * BottomBarMenuItem Specification
 * @module BottomBarMenu
 * @flow
 */

import { compose, withHandlers } from 'recompose';

import { BridgeService } from '~/mobile/app/services';

import { BottomBarMenuItem as BMI } from './BottomBarMenuItem';

const enhance = compose(
  // $FlowIssue
  withHandlers({
    onPseudoLinkTouch: ({ href }) => () => BridgeService.openUrlInBrowser(href),
  }),
);

export const BottomBarMenuItem = enhance(BMI);
